var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-module"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.config.map.link,"allowfullscreen":"","loading":"lazy"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }